import React, { Component } from "react";

class SimpleLabel extends Component {
  render() {
    return (
      <span
        className="fs-7 px-2 rounded-3 bg-white position-absolute color-main"
        style={{ top: "-8px", right: "18px" }}
      >
        {this.props.text}
      </span>
    );
  }
}

export default SimpleLabel;
